      class ProductItemVariants extends HTMLElement {
        constructor(){
          super();
          const productItemVariants = this.querySelectorAll('.product-item__variant');
          const productLink = this.closest('.product-item').querySelector('.product-item__link');
          let variantZIndex = 9;
          setTimeout(()=>{
            productItemVariants.forEach(elm=>{
              if ( this.querySelector('.product-item__variant-image') && productLink.querySelector('.product-item__image') ) {
                productLink.querySelector('.product-item__image').appendChild(this.querySelector('.product-item__variant-image'));
              }
              elm.addEventListener('click', e=>{
                productItemVariants.forEach(elm=>{elm.classList.remove('active')});
                e.currentTarget.classList.add('active');
                productLink.setAttribute('href', e.currentTarget.dataset.href);
                const variantImage = productLink.querySelector(`.product-item__variant-image[data-id="${e.currentTarget.dataset.id}"]`);
                if ( variantImage ) {
                  variantImage.classList.remove('active');
                  variantImage.style.zIndex = ++variantZIndex;
                  setTimeout(()=>{
                    variantImage.classList.add('active');
                  }, 10);
                }
              })
            })
          }, 500);
        }
      }
      customElements.define('product-item-variants', ProductItemVariants);
